// Plugin.
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';

// Component.
import HomeSlider from '../../../components/Home/HomeSlider';

// Action and Helper.
import { setStickyBottom } from '../../../actions/Sticky/StrickyActions';

// Style.
import s from './SimilarListings.css';

const SimilarListings = ({ data, hideHeading, viewListingSimilarItem }) => {

    const dispatch = useDispatch();
    const [smallDevice, setSmallDevice] = useState(false);

    useEffect(() => {
        let sticky = document.querySelector('[data-sticky-bottom]'), stickyBottom = 1615; //2474;
        stickyBottom = (sticky.getBoundingClientRect().top);
        let bottomElementHeight = 600;
        let windowHeight = document.documentElement.getBoundingClientRect().height || 3000;
        let isBrowser = typeof window !== 'undefined';
        if (isBrowser) {
            handleResize();
            window.addEventListener('resize', handleResize);
        }
        if (!smallDevice) {
            document.addEventListener('scroll', () => {
                windowHeight = document.documentElement.getBoundingClientRect().height;
                if ((windowHeight - bottomElementHeight) > stickyBottom) {
                    stickyBottom = windowHeight - bottomElementHeight;
                    dispatch(setStickyBottom(stickyBottom + 20));
                }
            });
        }
        stickyBottom = (sticky.getBoundingClientRect().top > stickyBottom) ? sticky.getBoundingClientRect().top : stickyBottom;
        dispatch(setStickyBottom(stickyBottom));

        return () => {
            let isBrowser = typeof window !== 'undefined';
            if (isBrowser) {
                window.removeEventListener('resize', handleResize);
            }
        }
    }, [setStickyBottom]);

    const handleResize = (e) => {
        let isBrowser = typeof window !== 'undefined';
        let smallDevice = isBrowser ? window.matchMedia('(max-width: 768px)').matches : false;
        setSmallDevice(smallDevice);
    };

    return (
        <div data-sticky-bottom>
            <HomeSlider data={data} hideHeading={hideHeading} isViewListing={true} viewListingSimilarItem={viewListingSimilarItem} skeletonClass='fourCardSkeleton' />
        </div>
    );
}

SimilarListings.propTypes = {
    data: PropTypes.any
};

SimilarListings.defaultProps = {
    data: null
};

export default withStyles(s)(SimilarListings);